<template>
    <section class="message">
        <div class="row center-block">
            <h1 class="text-center">Message</h1>

            <div class="col-md-12">
                <div class="box">
                    <div class="box-header col-md-2">
                        <h3 class="box-title">List</h3>
                    </div>
                    <div class="box-header col-md-8 text-center">
                        <div class="box-body">
                            <div class="row">
                                <div class="col-md-12 table-responsive">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box-header col-md-2 text-right">
                        <router-link :to="{name: 'addMessage' }">
                            <button
                                type="button"
                                data-toggle="tooltip"
                                data-placement="top"
                                :title="$t('add')"
                                :class="'btn btn-lg btn-primary'">
                                <i
                                    class="fa fa-plus"
                                    aria-hidden="true">
                                </i> &nbsp;Add
                            </button>
                        </router-link>
                    </div>
                    <!-- /.box-header -->
                    <div class="box-body">
                        <div
                            id="example_wrapper"
                            class="dataTables_wrapper form-inline dt-bootstrap">

                            <div class="row">
                                <div class="col-sm-12 table-responsive">
                                    <div id="message">
                                        <v-server-table
                                            url="/"
                                            :columns="columns"
                                            :options="options">
                                            <div slot="filter__checkbox">
                                                <input
                                                    v-model='allMarked'
                                                    type="checkbox"
                                                    v-on:change="$_admin_message_list_toggleAll()"
                                                />
                                                &nbsp;
                                                <button
                                                    class="btn btn-danger btn-sm"
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    :title="$t('deleteSelected')"
                                                    @click="$_admin_message_list_removeAll()">
                                                    <i class="glyphicon glyphicon-trash"></i>
                                                </button>
                                            </div>


                                            <template slot="checkbox" slot-scope="props">
                                                <input
                                                    v-model="markedRows"
                                                    type="checkbox"
                                                    v-bind:value="props.row.messageId"
                                                    v-on:change="$_admin_message_list_unmarkAll()"
                                                />
                                                {{props.row.messageId}}
                                            </template>
                                        </v-server-table>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- /.box-body -->
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
    import moment from 'moment'
    import api from '../../api'
    import config from '../../config'
    import action from './ListMessageAction'

    export default {
        name: 'MessageList',
        components: {
        },
        mounted () {
        },
        watch: {
            '_i18n.locale': function (newVal, oldVal) {
                const i18nSetting = this.$_admin_message_list_translation()
                this.columns = i18nSetting.columns
                this.options.templates = i18nSetting.templates
                this.options.texts = i18nSetting.texts
                this.options.filterable = i18nSetting.filterable
                this.options.listColumns = i18nSetting.listColumns
                this.options.columnsClasses = i18nSetting.columnsClasses
                for (let i = 0; i < i18nSetting.filterable.length; i++) {
                    this.$children[1].query[i18nSetting.filterable[i]] = ''
                }
            },
            isRefresh: function (newVal, oldVal) {
                this.$children[1].refresh()
            }
        },
        data () {
            const i18nSetting = this.$_admin_message_list_translation()
            return {
                totalRow: [],
                allMarked: false,
                markedRows: [],
                columns: i18nSetting.columns,
                options: {
                    filterByColumn: true,
                    templates: i18nSetting.templates,
                    texts: i18nSetting.texts,
                    filterable: i18nSetting.filterable,
                    listColumns: i18nSetting.listColumns,
                    columnsClasses: i18nSetting.columnsClasses,
                    sortable: [],
                    debounce: 1000,
                    perPage: 10,
                    requestKeys: {
                        limit: 'limit',
                        orderBy: 'sort',
                        page: 'page'
                    },
                    requestFunction: this.$_admin_message_list_requestFun,
                    responseAdapter (resp) {
                        this.totalRow = resp.payload
                        return { data: resp.payload, count: resp.query.total }
                    }
                }
            }
        },
        methods: {
            $_admin_message_list_requestFun (data) {
                const path = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiMessage
                const headers = {'authorization': this.$store.state.token}
                const params = Object.assign({}, data)
                if (data.query.status) {
                    params.status = data.query.status
                }
                if (data.query['title']) {
                    params.title = data.query['title']
                }
                if (data.query['message']) {
                    params.message = data.query['message']
                }
                if (data.query['status']) {
                    params.status = data.query['status']
                }
                console.log('query param===')
                console.log(params)
                delete params.query
                delete params.sort
                delete params.ascending
                delete params.byColumn
                return api.request('get', path, {}, params, headers)
                        .then(response => {
                            return Promise.resolve(response.data.data)
                        })
                    .catch(function (e) {
                        this.$children[1].dispatch('error', e)
                    }.bind(this))
            },
            $_admin_message_list_unmarkAll () {
                this.allMarked = false
            },
            $_admin_message_list_toggleAll () {
                this.markedRows = this.allMarked ? this.$children[1].data.map(row => row.messageId) : []
            },
            $_admin_message_list_removeAll () {
                let ids = []
                this.$children[1].data.map((row, index) => {
                    this.markedRows.map(markRow => {
                        if (row.messageId === markRow) {
                            ids.push(row.messageId)
                            delete this.$children[1].data[index]
                        }
                    })
                })
                const path = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiMessage
                const headers = {'authorization': this.$store.state.token}
                const params = { ids: ids.join(',') }
                return api.request('delete', path, {}, params, headers)
                    .then(response => {
                        this.$children[1].refresh()
                    })
            },
            $_admin_message_list_translation (langCode) {
                const i18n = this.$parent.$i18n
                const locale = i18n.locale
                const updatedAt = i18n.messages[locale].updatedAt
                let result = {}
                result.columns = ['checkbox', 'title', 'message', 'status', 'publishAfter', updatedAt, 'action']
                result.templates = {
                    action
                }
                result.templates['publishAfter'] = function (h, row) {
                    const time = moment(row.publishAfter).format('YYYY-MM-DD HH:mm:ss')
                    return time
                }
                result.templates[updatedAt] = function (h, row) {
                    const time = moment(row.updatedAt).format('YYYY-MM-DD HH:mm:ss')
                    return time
                }
                result.texts = {
                    filterBy: i18n.messages[locale].filterBy,
                    defaultOption: i18n.messages[locale].defaultOption
                }
                result.filterable = ['title', 'message', 'status']
                result.listColumns = {}
                result.listColumns['status'] = [
                    {id: 'unconfirmed', text: 'unconfirmed'},
                    {id: 'confirmed', text: 'confirmed'},
                    {id: 'archived', text: 'archived'}
                ]
                result.columnsClasses = {}
                result.columnsClasses['checkbox'] = 'col-md-2'
                result.columnsClasses['title'] = 'col-md-2'
                result.columnsClasses['message'] = 'col-md-2'
                result.columnsClasses['publishAfter'] = 'col-md-2'
                result.columnsClasses['status'] = 'col-md-1'
                result.columnsClasses[updatedAt] = 'col-md-2'
                result.columnsClasses['action'] = 'col-md-1'
                return result
            }
        }
    }
</script>

<style scoped>
    @import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

    table.dataTable thead .sorting:after,
    table.dataTable thead .sorting_asc:after,
    table.dataTable thead .sorting_desc:after {
        font-family: 'FontAwesome';
    }

    table.dataTable thead .sorting:after {
        content: "\f0dc";
    }

    table.dataTable thead .sorting_asc:after {
        content: "\f0dd";
    }

    table.dataTable thead .sorting_desc:after {
        content: "\f0de";
    }
</style>



// WEBPACK FOOTER //
// ListMessage.vue?48416683